module.exports = __webpack_public_path__ + "media/videogreed.80de1bcf.mp4";